import { Link, useLocation } from "@tanstack/react-router";

export default function OrgLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  const tabs = [
    { path: "/org", label: "Overview", exact: true },
    { path: "/org/members", label: "Members" },
    { path: "/org/competitions", label: "Competitions" },
    { path: "/org/settings", label: "Settings" },
  ];

  function isActive(tab: { path: string; exact?: boolean }) {
    if (tab.exact) return location.pathname === tab.path;
    return location.pathname.startsWith(tab.path);
  }

  return (
    <div className="min-h-screen bg-background relative">
      <div className="h-screen overflow-y-auto">
        <div className="flex flex-col px-5 pt-3 pb-9 gap-5 md:px-5 max-w-4xl mx-auto">
          <div className="flex items-center gap-3">
            <Link
              to="/dashboard"
              className="py-1.5 px-2.5 border border-[rgba(28,27,46,0.1)] rounded-[16px] bg-[rgba(255,255,255,0.4)] no-underline"
            >
              <span className="text-text-muted text-[0.8125rem] font-bold">&larr; Dashboard</span>
            </Link>
            <span className="text-text text-[1.75rem] font-black tracking-[-0.0313em]">Admin</span>
          </div>

          <div
            role="tablist"
            aria-label="Organization tabs"
            className="flex flex-row gap-1 bg-[rgba(0,0,0,0.04)] rounded-2xl p-0.5 overflow-x-auto"
          >
            {tabs.map((tab) => (
              <Link
                key={tab.path}
                to={tab.path}
                role="tab"
                aria-selected={isActive(tab)}
                aria-controls="org-tabpanel"
                className={`flex-1 py-2 text-center rounded-xl no-underline min-w-fit px-3 ${
                  isActive(tab) ? "bg-aqua" : ""
                }`}
              >
                <span
                  className={`text-xs font-semibold ${
                    isActive(tab) ? "text-white" : "text-text-muted"
                  }`}
                >
                  {tab.label}
                </span>
              </Link>
            ))}
          </div>

          <div id="org-tabpanel" role="tabpanel" aria-label="Organization content">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
